import { NgIf } from "@angular/common";
import { Component, HostBinding, Input } from "@angular/core";
import { SpinnerComponent } from "app/shared/components/spinner/spinner.component";

@Component({
  selector: "[loading-area-indicator]",
  templateUrl: "./loading-area-indicator.component.html",
  styleUrls: ["./loading-area-indicator.component.scss"],
  imports: [NgIf, SpinnerComponent],
})
export class LoadingAreaIndicatorComponent {
  @Input() public loadingAreaIndicatorActive: boolean = false;

  @HostBinding("class.loading-area-active")
  get loadingAreaActiveClass(): boolean {
    return this.loadingAreaIndicatorActive;
  }
}
